import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['details', 'button'];

  connect() {
    this.expanded = false;
  }

  toggleAll() {
    this.expanded = !this.expanded;
    this.detailsTargets.forEach((details) => {
      details.open = this.expanded;
    });

    this.buttonTarget.textContent = this.expanded ? 'Collapse all sections' : 'Expand all sections';
    this.buttonTarget.ariaExpanded = this.expanded ? 'true' : 'false';
  }
}
